import { Pager } from '../global'

export type ResponseGetHomeStats = {
  /** 更新时间 date-time */
  lastUpdateTime: string

  /** 全部-供货金额近7天 */
  allSupplyAmountLast7Days: number
  /** 全部-供货金额近7天环比 */
  allSupplyAmountLast7DaysRingRatio: string
  /** 全部-供货金额本月 */
  allSupplyAmountMonth: number
  /** 全部-供货金额本月环比 */
  allSupplyAmountMonthRingRatio: string
  /** 摇钱树-供货金额近7天 */
  scwSupplyAmountLast7Days: number
  /** 摇钱树-供货金额近7天环比 */
  scwSupplyAmountLast7DaysRingRatio: string
  /** 摇钱树-供货金额本月 */
  scwSupplyAmountMonth: number
  /** 摇钱树-供货金额本月环比 */
  scwSupplyAmountMonthRingRatio: string
  /** 自营-供货金额近7天 */
  selfSupplyAmountLast7Days: number
  /** 自营-供货金额近7天环比 */
  selfSupplyAmountLast7DaysRingRatio: string
  /** 自营-供货金额本月 */
  selfSupplyAmountMonth: number
  /** 自营-供货金额本月环比 */
  selfSupplyAmountMonthRingRatio: string

  /** 全部-订单满足率近30天 */
  allOrderFulfillRateLast30Days: string
  /** 全部-订单满足率近30天环比 */
  allOrderFulfillRateLast30DaysRingRatio: string
  /** 全部-订单满足率本月 */
  allOrderFulfillRateMonth: string
  /** 全部-订单满足率本月环比 */
  allOrderFulfillRateMonthRingRatio: string
  /** 摇钱树-订单满足率近30天 */
  scwOrderFulfillRateLast30Days: string
  /** 摇钱树-订单满足率近30天环比 */
  scwOrderFulfillRateLast30DaysRingRatio: string
  /** 摇钱树-订单满足率本月 */
  scwOrderFulfillRateMonth: string
  /** 摇钱树-订单满足率本月环比 */
  scwOrderFulfillRateMonthRingRatio: string
  /** 自营-订单满足率近30天 */
  selfOrderFulfillRateLast30Days: string
  /** 自营-订单满足率近30天环比 */
  selfOrderFulfillRateLast30DaysRingRatio: string
  /** 自营-订单满足率本月 */
  selfOrderFulfillRateMonth: string
  /** 自营-订单满足率本月环比 */
  selfOrderFulfillRateMonthRingRatio: string
}

export type ResponseGetHomeTodoOrder = {
  /** 全部-可发货 */
  allCanDeliverCount: number
  /** 全部-待确认 */
  allPendingConfirmCount: number
  /** 全部-未读关闭 */
  allUnreadClosedOrderCount: number
  /** 全部-未读拒收 */
  allUnreadRejectTotal: number
  /** 全部-未读采退 */
  allUnreadReturnTotal: number
  /** 全部-药检报告待上传数 */
  drugReportPendingTotal: number
  /** 摇钱树-可发货 */
  scwCanDeliverCount: number
  /** 摇钱树-待确认（恒为 0 或 null）；无摇钱树合作为 null */
  scwPendingConfirmCount: number
  /** 摇钱树-未读关闭 */
  scwUnreadClosedOrderCount: number
  /** 摇钱树-未读拒收 */
  scwUnreadRejectTotal: number
  /** 摇钱树-未读采退 */
  scwUnreadReturnTotal: number
  /** 摇钱树-药检报告待上传数 */
  scwDrugReportPendingTotal: number
  /** 自营-可发货 */
  selfCanDeliverCount: number
  /** 自营-待确认；无自营合作为 null */
  selfPendingConfirmCount: number
  /** 自营-未读关闭 */
  selfUnreadClosedOrderCount: number
  /** 自营-未读拒收 */
  selfUnreadRejectTotal: number
  /** 自营-未读采退 */
  selfUnreadReturnTotal: number
  /** 自营-药检报告待上传数 */
  selfDrugReportPendingTotal: number
}

export type ResponseGetScwProduct = {
  /** 批件过期品种数。来源：运营中品种-异常-批件过期。跳转：运营中品种 Tab，品种状态=异常+批件过期 */
  approvalExpiredCount: number
  /** 近效期品种数。来源：运营中品种-近效期。跳转：运营中品种 Tab，品种状态=近效期 */
  nearExpiryCount: number
  /** 即将失效品种数。来源：运营中品种-异常-即将失效。跳转：运营中品种 Tab，品种状态=异常+即将失效 */
  nearInvalidCount: number
  /** 新申报品种数。来源：品种管理-运营中品种-新申报。跳转：运营中品种 Tab，品种状态=新申报品种 */
  newDeclareVarietyCount: number
  /** 已驳回商品数。来源：申报管理-已驳回。跳转：申报管理，商品资料状态=已驳回 */
  rejectedCount: number
  /** 建议补货品种数。来源：运营中品种-建议补货。跳转：运营中品种 Tab，品种状态=建议补货 */
  suggestReplenishCount: number
  /** 待维护商品数。来源：申报管理-待维护。跳转：申报管理，商品资料状态=待维护（drug_sum_status=-1 等，与现有申报列表筛选项一致） */
  toBeMaintainedCount: number
  visible: boolean
}

export type ResponseGetCallNotice = {
  /** 成功反馈-新增报价促成订单金额合计 */
  promotedOrderAmount: number
  /** 成功反馈-新增报价促成的供货订单数量 */
  promotedOrderCount: number
}

export type ResponseGetQuoteBoardSummary = {
  /** 新商机-期次序号 X，对应「第 X 期」中的 X；无进行中报价期时为 null */
  periodSeq: number
  /** 新商机-剩余整天天数 */
  remainingDays: number
  /** 新商机-除去整天后剩余小时数（0-23） */
  remainingHours: number
  /** 待办提醒-天数；无待办时为 null */
  reminderDays: number
  /** 对码协同-已对码数量=0 时是否展示提示：0 否，1 是；不展示时可 null */
  zeroCodedPromptFlag: number
  /** 对码协同-商品对码成功率(%)，如 98.54 表示 98.54%；保留两位小数 */
  matchSuccessRate: number
}

/** 标记订单代办已读类型 */
export enum KINE_MARK_ORDER_TODO_READ {
  /** 未读关闭订单 */
  UN_READ_CLOSED_ORDER = 0,
  /** 未读入库拒收 */
  UN_READ_REJECT = 1,
  /** 未读采退 */
  UN_READ_RETURN = 2
}
export type ParamsMarkOrderTodoRead = {
  /** 类型：0-未读关闭订单 1-未读入库拒收 2-未读采退 */
  kind: number
  /** 0-全部 1-自营 2-摇钱树。kind=0 关闭单仅 0/1 有效且不标摇钱树；kind=1 双业务并存时不标拒收；kind=2 采退仅 0 有效 */
  scope: number
}

export type ResponseGetHomeChannelList = string[]

export type ResponseGetHomeUnInvoiceCount = {
  /** 摇钱树-实销实结 */
  cashCowSalesSettlementCount: number
  /** 自营-账期 */
  selfAccountPeriodCount: number
  /** 自营-实销实结 */
  selfSalesSettlementCount: number
  /** 总未开票数量 */
  totalCount: number
}

/** 账号的合作业务类型 */
export enum ACCOUNT_BUSINESS_TYPE_ENUM {
  /** 普品 */
  GENERAL_GOODS = 1,
  /** 首推 */
  FIRST_RECOMMEND = 2,
  /** 摇钱树 */
  CASH_COW = 3,
  /** 集采 */
  CENTRALIZED_PURCHASE = 4,
  /** 控销 */
  CONTROLLED_SALES = 5
}
export interface AmountInfo {
  /** 按业务类型区分的列表 */
  businessTypeAmountGroupList: {
    /** 金额 */
    amount: number
    /** 业务类型 */
    businessType: ACCOUNT_BUSINESS_TYPE_ENUM
  }[]
  /** 总金额 */
  totalAmount: number
}
export interface ResponseGetLeyoPayData {
  /** 应付金额 */
  remainPayAmount: AmountInfo | null
  /** 待结算金额 */
  waitWithdrawAmount: AmountInfo | null
  /** 可提现金额 */
  withdrawableAmount: AmountInfo | null
  /** 具有资金提现管理页面权限的业务类型  */
  withdrawManagePermissionList: number[]
  /** 具有资金申请提现页面权限的业务类型 */
  applyWithdrawPermissionList: number[]
  /** 摇钱树利润查看页面权限 */
  queryCashCowProfitPermission: boolean
}

// 账号下已授权系统
export enum SUB_SYSTEM_ENUM {
  LEYO_PAY = 3, // 结算系统
  ISUPPLIER = 900, // isupplier
  SCM = 1000, // scm
  FIRST_PURCHASED = 1200, // 首营
  DEFAULT = '' // 其他
}
/** 用户信息 */
export type SrmUserInfo = {
  /** 当前账号 */
  account: string
  /** 是否完成新手指引 0：未完成 1：已完成 */
  beNewbieFinish: number
  /** 该手机是否第一次登录 */
  firstLoginFlag: number
  /** 该手机第一次登录的时间 date-time */
  firstLoginTime: string
  /** 是否需要更新密码 */
  passwordUpdateFlag: number
  /** 手机号 */
  phone: string
  /** 上次密码更新时间 date-time */
  pwUpdateTime: string
  /** 供应商中台编码 */
  supplierCode: string
  /** 供应商名称 */
  supplierName: string
  /** 姓名 */
  uname: string
  /** 用户 id */
  userId: number
  /** 用户类型 */
  userType: number
  /** 该用户是否已绑定微信 */
  wechatBindFlag: number
  /** isupplier子账号开通权限：0-禁用 1-启用 */
  beAllowOpenSubAccount: number
  /** 是否自营主账号(有关联的授权委托函)：0-否，1-是 */
  beSelfOpMainAccount: number
  /** 对应的主账号id, 0表示该账户为主账号 */
  mainId: number
  /** 是否是rc */
  isRc: number
}
export type ResponseSrmUserInfo = {
  /** 合作业务类型 */
  businessTypeList: ACCOUNT_BUSINESS_TYPE_ENUM[]
  /** 有权限的菜单列表 */
  modules: string[]
  /** 合作子公司 - 接口返回了，暂时用不到 */
  providerList: number[]
  /** 已授权系统列表 */
  subsystemList: SUB_SYSTEM_ENUM[]
  /** 用户信息 */
  userInfo: SrmUserInfo
}

export type ResponseGetNewbieFinish = {
  beFinishNewbieGuide: number
}

export enum NEWBIE_FINISH_TYPE_ENUM {
  GYS_WEB = 1,
  ISUPPLIER = 2
}
export type ParamsSetNewbieFinish = {
  /** 指引类型：1-gys-web 2-isupplier */
  type: NEWBIE_FINISH_TYPE_ENUM
}
